import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Header from './components/Header';
import "./assets/scss/style.scss";
import Login from './components/Login';
import ForgotPassword from './components/ForgotPassword';
import Dashboard from "./components/pages/Dashboard";
import Products from "./components/pages/Products";
import Orders from "./components/pages/Orders";
import Filters from "./components/pages/Filters";
import AttributePricing from "./components/pages/AttributePricing";
import Profile from "./components/pages/Profile";
import Notifications from "./components/pages/Notifications";
import Agents from "./components/pages/Agents";
import AgentCommission from './components/pages/AgentCommission';
import Customers from './components/pages/Customers';

const PrivateRoute = ({ children }) => {
  const isAuthenticated = !!localStorage.getItem("token");
  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

const AdminRoute = ({ children }) => {
  const isAuthenticated = !!localStorage.getItem("token");
  const userRole = localStorage.getItem("userRole");
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  return userRole !== "vendor" ? children : <Navigate to="/dashboard" replace />;
};

function App() {

  const [isAuthenticated, setIsAuthenticated] = useState(
    !!localStorage.getItem("token")
  );

  // Auto update without refresh
  useEffect(() => {
    const listener = () => {
      setIsAuthenticated(!!localStorage.getItem("token"));
    };

    window.addEventListener("storage", listener);
    window.addEventListener("auth-changed", listener);

    return () => {
      window.removeEventListener("storage", listener);
      window.removeEventListener("auth-changed", listener);
    };
  }, []);

  return (
    <Router>
      {isAuthenticated && <Header />}

      <div className="container mt-4">
        <Routes>
          <Route
            path="/"
            element={
              localStorage.getItem("token") ? (
                <Navigate to="/dashboard" replace />
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />

          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />

          <Route path="/dashboard" element={
            <PrivateRoute><Dashboard /></PrivateRoute>
          } />

          <Route path="/products" element={
            <PrivateRoute><Products /></PrivateRoute>
          } />

          <Route path="/orders" element={
            <PrivateRoute><Orders /></PrivateRoute>
          } />

          <Route path="/filters" element={
            <AdminRoute><Filters /></AdminRoute>
          } />

          <Route path="/attribute-pricing" element={
            <AdminRoute><AttributePricing /></AdminRoute>
          } />

          <Route path="/profile" element={
            <PrivateRoute><Profile /></PrivateRoute>
          } />

          <Route path="/notifications" element={
            <PrivateRoute><Notifications /></PrivateRoute>
          } />

          <Route path="/agents" element={
            <AdminRoute><Agents /></AdminRoute>
          } />

          <Route path="/agent-commission" element={
            <AdminRoute><AgentCommission /></AdminRoute>
          } />

          <Route path="/customers" element={
            <PrivateRoute><Customers /></PrivateRoute>
          } />

          {/* Wildcard route to handle all other unmatched URLs */}
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;